import React from 'react';

interface IProps {
  id: string;
  currentPage: number;
  totalPages: number;
  lightBackground?: boolean;
  className?: string;
  smallIndicatorSpacing?: boolean;
  onClick: (page: number) => void;
}

export const PageIndicator = ({
  currentPage,
  totalPages,
  id,
  lightBackground = true,
  className = '',
  smallIndicatorSpacing = false,
  onClick,
}: IProps) => {
  if (!totalPages || Number.isNaN(totalPages) || totalPages <= 1) {
    return <></>;
  }
  const getClassName = (index: number): string => {
    if (index + 1 === currentPage) {
      return lightBackground
        ? 'border-midnight md:hover:border-twilight'
        : 'border-twilight md:hover:border-abyss';
    }
    return lightBackground
      ? 'border-twilight md:hover:border-midnight'
      : 'border-abyss md:hover:border-twilight';
  };

  return (
    <div
      className={`mx-auto ${className} ${smallIndicatorSpacing ? 'mt-2' : 'mt-6'}`}
      data-testid="PageIndicator"
    >
      {[...Array(totalPages)].map((_, i) => (
        <button
          type="button"
          key={`${id}-p-${i}`}
          onClick={() => {
            onClick(i + 1);
          }}
          className={`${getClassName(
            i,
          )} mr-2 rounded-full border-4 outline-hidden focus:outline-hidden`}
          aria-label={`Page ${i + 1} ${i + 1 === currentPage ? 'current page' : ''}`}
          aria-current={i + 1 === currentPage}
        />
      ))}
    </div>
  );
};
